module.exports = __webpack_public_path__ + "img/img_asset_valve_joint.fc86daa1.svg";